/**
 * Waits a certain time and then returns
 * @param ms time to wait
 */
const wait = (ms: number): Promise<never> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export default wait;
